import { motion } from 'framer-motion'
import DocsLayout from '../components/DocsLayout'
import SEO from '../components/SEO'
import { 
  FaTools, 
  FaFire, 
  FaCompactDisc, 
  FaRocket, 
  FaBolt, 
  FaWindows, 
  FaStar, 
  FaMagic,
  FaUsb,
  FaKey,
  FaDownload,
  FaApple,
  FaDesktop
} from 'react-icons/fa'

const peTools = [
  {
    name: "微PE工具箱",
    description: "一款实用的PE工具，能够极大地简化电脑系统的安装和维护过程。支持10PE和8PE系统，还支持安装到系统开机启动项、制作可启动U盘、移动硬盘、生成ISO镜像及Win11系统的安装。还集成了多种功能和工具，如格式化、磁盘分区、密码恢复等，体积小巧，性价比高。",
    url: "https://www.wepe.com.cn/",
    icon: <FaTools className="text-blue-500" />,
    features: ["支持10PE和8PE", "支持Win11安装", "集成多种工具", "体积小巧"]
  },
  {
    name: "HotPE工具箱",
    description: "一个纯净、强大、优雅的开源Win11PE，集成了上网、声音、远程、下载、HotPE模块、Edgeless插件、MTP、RNDIS等多种实用功能，还支持U盘和本地启动，让您在没有硬盘的情况下也能启动计算机。",
    url: "https://www.hotpe.top/",
    icon: <FaFire className="text-red-500" />,
    features: ["开源Win11PE", "支持上网功能", "支持远程控制", "支持本地启动"]
  },
  {
    name: "Rufus",
    description: "一个开源免费的快速制作 U 盘系统启动盘和格式化 USB 的实用小工具，它可以快速把 ISO 格式的系统镜像文件快速制作成可引导的 USB 启动安装盘，支持 Windows 或 Linux 启动。Rufus 小巧玲珑，软件体积仅 7 百多 KB，然而麻雀虽小，它却五脏俱全。",
    url: "https://rufus.ie/downloads/",
    icon: <FaCompactDisc className="text-purple-500" />,
    features: ["开源免费", "快速制作", "支持多系统", "体积小巧"]
  },
  {
    name: "Ventoy",
    description: "新一代的多系统U盘启动制作工具，具备简单易用、完全免费和开源等优势。它支持超过1100+个映像文件，包括Windows、Linux、Debian、Ubuntu、CentOS、Unix和ChromeOS等。",
    url: "https://www.ventoy.net/cn/index.html",
    icon: <FaRocket className="text-green-500" />,
    features: ["支持1100+映像", "简单易用", "完全免费", "开源工具"]
  },
  {
    name: "BalenaEtcher",
    description: "一款简洁高效的启动盘制作工具。它能够将ISO文件刻录到U盘或硬盘中，以创建启动盘，操作简便且快速。此外，BalenaEtcher几乎支持所有操作系统的刻录，包括Windows、Mac和Linux。只需选择ISO文件和最终刻录目录，即可轻松完成启动盘制作。",
    url: "https://etcher.balena.io/",
    icon: <FaBolt className="text-yellow-500" />,
    features: ["跨平台支持", "操作简便", "快速刻录", "界面友好"]
  },
  {
    name: "WinToUSB",
    description: "一款强大且实用的U盘安装系统工具，只需要有Windows操作系统的iso镜像、CD或DVD，就能用u盘来安装Windows操作系统。",
    url: "https://www.easyuefi.com/wintousb/index-cn.html",
    icon: <FaWindows className="text-blue-600" />,
    features: ["支持Windows安装", "操作简单", "功能强大", "稳定可靠"]
  },
  {
    name: "FirPE",
    description: "最适合年轻人使用的第三方WinPE，这款软件以其简约、易操作的界面，人性化的设计，以及高效的实用性，同样是装机爱好者们的必备神器。",
    url: "https://www.firpe.cn/",
    icon: <FaStar className="text-orange-500" />,
    features: ["界面简约", "易操作", "人性化设计", "高效实用"]
  },
  {
    name: "Edgeless",
    description: "强大而优雅的半开源PE工具，基于WIN10创建的PE工具，软件体积极小，也非常的干净，坚守无广告、无收费、无劫持的原则，用惯了传统WIN10系统的用户可以尝试一下软件。",
    url: "https://home.edgeless.top/",
    icon: <FaMagic className="text-indigo-500" />,
    features: ["基于Win10", "无广告", "无收费", "无劫持"]
  }
]

const sidebarItems = [
  { title: "装机工具", path: "/tools", icon: <FaTools /> },
  { title: "PE工具", path: "/petools", icon: <FaCompactDisc /> },
  { title: "激活工具", path: "/activators", icon: <FaKey /> },
  { title: "系统下载", path: "/downloads", icon: <FaDownload /> },
  { title: "Windows软件", path: "/windows-software", icon: <FaWindows /> },
  { title: "MacOS软件", path: "/macos-software", icon: <FaApple /> },
  { title: "安装U盘推荐", path: "/usb-recommend", icon: <FaUsb /> },
  { title: "电脑选购推荐", path: "/computer-recommend", icon: <FaDesktop /> }
]

const PEtools = () => {
  return (
    <DocsLayout sidebarItems={sidebarItems}>
      <SEO 
        title="U盘制作PE工具大全 | Win10/Win11系统安装启动盘制作软件"
        description="收集多款免费、纯净且功能强大的装机必备U盘制作PE工具，帮助你轻松制作Win10/Win11系统安装启动盘，让系统重装过程更加便捷高效。"
        keywords="PE工具,U盘启动工具,微PE,VENTOY,RUFUS,U盘重装工具,Win10启动盘制作,Win11系统安装,U盘启动盘制作软件,系统重装工具"
      />
      <motion.h1 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-bold text-primary mb-8 text-center"
      >
        U盘制作PE工具 <FaUsb className="inline text-primary ml-1" />
      </motion.h1>

      <div className="mb-8 text-center text-gray-600">
        <p className="text-lg">
          这里收集了多款免费、纯净且功能强大的装机必备U盘制作PE工具，
          这些工具都能帮助你轻松制作系统启动盘，让你的装机过程更加便捷。
        </p>
      </div>
      
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {peTools.map((tool, index) => (
          <motion.div
            key={tool.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="card"
          >
            <div className="flex items-center mb-4">
              <div className="text-2xl mr-3">{tool.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800">{tool.name}</h3>
            </div>
            <p className="text-gray-600 mb-4">{tool.description}</p>
            <div className="mb-4">
              <h4 className="font-medium text-gray-700 mb-2">特点：</h4>
              <ul className="list-disc list-inside text-sm text-gray-600">
                {tool.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
            </div>
            <a
              href={tool.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
            >
              获取工具
            </a>
          </motion.div>
        ))}
      </div>
    </DocsLayout>
  )
}

export default PEtools